import { render, staticRenderFns } from "./QaModal.vue?vue&type=template&id=3fc98aa8&"
import script from "./QaModal.vue?vue&type=script&lang=js&"
export * from "./QaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fc98aa8')) {
      api.createRecord('3fc98aa8', component.options)
    } else {
      api.reload('3fc98aa8', component.options)
    }
    module.hot.accept("./QaModal.vue?vue&type=template&id=3fc98aa8&", function () {
      api.rerender('3fc98aa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/basic/qa/modules/QaModal.vue"
export default component.exports